(() => {
  const initializeBgbCartForms = (root = document) => {
    root.querySelectorAll('[data-bgb-cart-scope]').forEach((scope) => {
      if (scope.dataset.cartReady === 'true') return;
      const form = scope.querySelector('form[action*="/cart/add"]');
      const button = form && form.querySelector('[data-bgb-add], button[name="add"]');
      const feedback = scope.querySelector('[data-bgb-cart-feedback]');
      if (!form || !button || !feedback) return;
      scope.dataset.cartReady = 'true';
      const submitCart = async () => {
        if (button.disabled || scope.dataset.cartSubmitting === 'true') return;
        const defaultLabel = button.textContent.trim();
        scope.dataset.cartSubmitting = 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = scope.dataset.addingLabel || defaultLabel;
        feedback.hidden = true;
        feedback.textContent = '';
        feedback.setAttribute('role', 'status');
        try {
          const shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const response = await fetch(`${shopRoot}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const result = await response.json();
          if (!response.ok) {
            const detail = result.description || result.message || scope.dataset.errorLabel;
            const isUnavailable = response.status === 422 && /sold out|unavailable/i.test(detail);
            feedback.textContent = isUnavailable ? scope.dataset.unavailableLabel : detail;
            feedback.hidden = false;
            feedback.setAttribute('role', 'alert');
            button.textContent = isUnavailable ? scope.dataset.soldOutLabel : defaultLabel;
            button.disabled = isUnavailable;
            return;
          }
          window.location.assign(scope.dataset.cartUrl || `${shopRoot}cart`);
        } catch (error) {
          feedback.textContent = scope.dataset.errorLabel;
          feedback.hidden = false;
          feedback.setAttribute('role', 'alert');
          button.textContent = defaultLabel;
          button.disabled = false;
        } finally {
          button.removeAttribute('aria-busy');
          scope.dataset.cartSubmitting = 'false';
        }
      };
      button.addEventListener('click', (event) => { event.preventDefault(); submitCart(); });
      form.addEventListener('submit', (event) => { event.preventDefault(); submitCart(); });
    });
  };

  initializeBgbCartForms();
  document.addEventListener('shopify:section:load', (event) => initializeBgbCartForms(event.target));

  const updateBgbHomeMobileBar = () => {
    const bar = document.querySelector('.bgb-mobile-bar--home');
    if (!bar) return;
    const hero = document.querySelector('.bgb-hero');
    bar.dataset.visible = !hero || hero.getBoundingClientRect().bottom <= 0 ? 'true' : 'false';
  };

  let bgbMobileBarFrame = null;
  const scheduleBgbHomeMobileBar = () => {
    if (bgbMobileBarFrame !== null) return;
    bgbMobileBarFrame = window.requestAnimationFrame(() => { bgbMobileBarFrame = null; updateBgbHomeMobileBar(); });
  };

  scheduleBgbHomeMobileBar();
  window.addEventListener('scroll', scheduleBgbHomeMobileBar, { passive: true });
  window.addEventListener('resize', scheduleBgbHomeMobileBar);
  document.addEventListener('shopify:section:load', scheduleBgbHomeMobileBar);
})();